import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

/**
 * MainLayout - Wraps page content ensuring proper spacing below fixed navbar
 * Prevents navbar overlap and provides consistent layout across all pages
 */
function MainLayout({ children, className = "", showFooter = true }) {
  // If className includes a background class, don't apply default bg-white
  const hasBackgroundClass = className.includes("bg-");
  const defaultBg = hasBackgroundClass ? "" : "bg-white";

  return (
    <>
      <Navbar />
      {/* pt-16 accounts for navbar height (h-16 = 64px) */}
      <main className={`pt-16 min-h-screen ${defaultBg} ${className}`}>
        {children}
      </main>
      {showFooter && <Footer />}
    </>
  );
}

export default MainLayout;
